import { Experiences } from '@/src/experiences'

export default Experiences.Notifications.Screens.GoToSystemSettings.Screen
